module.exports = __webpack_public_path__ + "img/qb4.5c8367a6.png";